<template>
  <div>
    <div id="venn-chart"></div>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsVenn from "highcharts/modules/venn";

HighchartsVenn(Highcharts); // 初始化 Venn 模块

export default {
  name: "CustomVennChart",
  props: {
    vennData: {
      type: Object,
      required: true
    }
  },
  methods: {
    renderChart() {
      Highcharts.chart("venn-chart", {
        chart: {
          type: "venn",
        },
        title: {
          text: "Custom Venn Diagram"
        },
        series: [
          {
            name: "Venn Data",
            data: this.vennChartData,
            layoutAlgorithm: {
              type: "venn",
              repulsion: 8, // 增加圆之间的排斥力以实现更散开的布局
              gravitationalConstant: 0.01, // 增加吸引力避免完全分离
              friction: 0.9 // 控制布局的稳定性
            },
            dataLabels: {
              enabled: true,
              formatter: function () {
                const total = this.series.points.reduce((sum, point) => sum + point.value, 0);
                const percentage = ((this.point.value / total) * 100).toFixed(1);
                return `${this.point.value} (${percentage}%)`;
              },
              style: {
                fontSize: "12px",
                fontWeight: "bold",
                color: "#000"
              },
              allowOverlap: false // 避免标签重叠
            }
          }
        ],
        tooltip: {
          headerFormat: "",
          pointFormat: "<b>{point.sets}</b>: {point.value}"
        }
      });
    }
  },
  mounted() {
    this.renderChart();
  },
  computed: {
    vennChartData() {
      const sets = Object.keys(this.vennData).map((key) => ({
        name: key,
        data: this.vennData[key]
      }));

      const chartData = [];

      // 单集合区域
      sets.forEach((set) => {
        chartData.push({
          sets: [set.name],
          value: set.data.length
        });
      });

      // 交集区域，包括显示为 0 的区域
      for (let i = 0; i < sets.length; i++) {
        for (let j = i + 1; j < sets.length; j++) {
          const intersection = sets[i].data.filter((x) => sets[j].data.includes(x));
          chartData.push({
            sets: [sets[i].name, sets[j].name],
            value: intersection.length || 0
          });
        }
      }

      // 添加中心区域 (所有集合的交集)
      const allIntersection = sets.reduce((acc, set) => acc.filter((x) => set.data.includes(x)), sets[0].data);
      chartData.push({
        sets: sets.map((set) => set.name),
        value: allIntersection.length || 0
      });

      return chartData; // 返回处理后的数据
    }
  }
};
</script>

<style scoped>
#venn-chart {
  margin: 0 auto;
}
</style>
